import { css } from '@emotion/core';
import { variables, rgba } from '@domain-group/fe-brary';
var colour = variables.colour,
  global = variables.global;
export var container = {
  name: "1jke4yk",
  styles: "position:relative;width:100%;"
};
export var ariaUnderlay = extraStyles => /*#__PURE__*/css("position:fixed;top:0;left:0;width:100%;height:100%;z-index:", global.layerModal, ";overflow:hidden;text-align:center;background:", rgba(colour.black, 0.9), ";cursor:pointer;", extraStyles);
export var ariaDialog = extraStyles => /*#__PURE__*/css("display:inline-block;text-align:left;top:0;max-width:100%;height:100vh;cursor:default;", extraStyles);
export var modalPanel = /*#__PURE__*/css("width:100vw;height:100%;min-height:100vh;background-color:", colour.white, ";");